function syncWishlistButtons(root) {
  var stored = JSON.parse(localStorage.getItem('vemica_wishlist') || '[]');
  root.querySelectorAll('.js-wishlist-btn').forEach(function (button) {
    var active = stored.indexOf(button.dataset.wishlistId) > -1;
    button.classList.toggle('is-active', active);
    button.setAttribute('aria-pressed', active ? 'true' : 'false');
  });
}

document.addEventListener('DOMContentLoaded', function () {
  syncWishlistButtons(document);
});

document.addEventListener('click', function (event) {
  var button = event.target.closest('.js-wishlist-btn');
  if (!button) return;
  var id = button.dataset.wishlistId;
  var stored = JSON.parse(localStorage.getItem('vemica_wishlist') || '[]');
  var index = stored.indexOf(id);
  if (index > -1) {
    stored.splice(index, 1);
  } else {
    stored.push(id);
  }
  localStorage.setItem('vemica_wishlist', JSON.stringify(stored));
  syncWishlistButtons(document);
});

var wishlistObserver = new MutationObserver(function () {
  syncWishlistButtons(document);
});
wishlistObserver.observe(document.body, { childList: true, subtree: true });
